/** Buy section — size pills, qty, /cart/add.js, sticky bar, toast, gallery tilt, reveals, FAQ. */
(function () {
  const SIZE_NOTES = {
    Small: "Men's US 7–8 · Women's US 6–7",
    Medium: "Men's US 8.5–10 · Women's US 7.5–9",
    Large: "Men's US 10.5–12 · Women's US 9–10",
    'X-Large': "Men's US 12–14 · Women's US 11.5–13",
    S: "Men's US 7–8 · Women's US 6–7",
    M: "Men's US 8.5–10 · Women's US 7.5–9",
    L: "Men's US 10.5–12 · Women's US 9–10",
    XL: "Men's US 12–14 · Women's US 11.5–13"
  };

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD'
    });
  }

  function initScrollReveals(root) {
    const nodes = (root || document).querySelectorAll('.zm-reveal');
    if (!nodes.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    nodes.forEach((el) => io.observe(el));
  }

  function initGalleryTilt(section) {
    if (reduceMotion) return;

    const gallery = section.querySelector('[data-zm-gallery-tilt]');
    const stage = gallery?.querySelector('.zm-pdp-gallery__stage') || gallery?.querySelector('[data-zm-main-img-wrap]');
    if (!gallery || !stage) return;

    let raf = 0;
    let targetX = 0;
    let targetY = 0;
    let currentX = 0;
    let currentY = 0;

    function tick() {
      currentX += (targetX - currentX) * 0.12;
      currentY += (targetY - currentY) * 0.12;
      stage.style.transform = `rotateX(${currentY}deg) rotateY(${currentX}deg)`;
      if (Math.abs(targetX - currentX) > 0.01 || Math.abs(targetY - currentY) > 0.01) {
        raf = requestAnimationFrame(tick);
      } else {
        raf = 0;
      }
    }

    function onMove(e) {
      const rect = stage.getBoundingClientRect();
      const px = (e.clientX - rect.left) / rect.width - 0.5;
      const py = (e.clientY - rect.top) / rect.height - 0.5;
      targetX = px * 8;
      targetY = -py * 6;
      stage.classList.add('is-tilting');
      if (!raf) raf = requestAnimationFrame(tick);
    }

    function onLeave() {
      targetX = 0;
      targetY = 0;
      stage.classList.remove('is-tilting');
      if (!raf) raf = requestAnimationFrame(tick);
    }

    gallery.addEventListener('pointermove', onMove);
    gallery.addEventListener('pointerleave', onLeave);
  }

  function initFaq(section) {
    const list = section.querySelector('[data-zm-faq-list]');
    if (!list) return;

    list.querySelectorAll('[data-zm-faq-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.zm-pdp-faq-item');
        if (!item) return;
        const opening = !item.classList.contains('is-open');
        const answer = item.querySelector('.zm-pdp-faq-a');

        list.querySelectorAll('.zm-pdp-faq-item.is-open').forEach((openItem) => {
          if (openItem === item) return;
          openItem.classList.remove('is-open');
          openItem.querySelector('[data-zm-faq-toggle]')?.setAttribute('aria-expanded', 'false');
          openItem.querySelector('.zm-pdp-faq-a')?.setAttribute('hidden', '');
        });

        item.classList.toggle('is-open', opening);
        btn.setAttribute('aria-expanded', opening ? 'true' : 'false');
        if (answer) {
          if (opening) answer.removeAttribute('hidden');
          else answer.setAttribute('hidden', '');
        }
      });
    });
  }

  document.querySelectorAll('[data-zm-buy-section]').forEach((section) => {
    const sectionId = section.dataset.zmBuySection;
    const form = section.querySelector('[data-zm-product-form]');
    const variantInput = section.querySelector('[data-zm-variant-id]');
    const qtyInput = section.querySelector('[data-zm-qty-input]');
    const qtyVal = section.querySelector('[data-zm-qty-val]');
    const priceNow = section.querySelector('[data-zm-price-now]');
    const priceWas = section.querySelector('[data-zm-price-was]');
    const btnPrice = section.querySelector('[data-zm-btn-price]');
    const sizeNote = section.querySelector('[data-zm-size-note]');
    const addBtn = section.querySelector('[data-zm-add-btn]');
    const mainImg = section.querySelector('[data-zm-main-img]') || section.querySelector('[data-zm-main-img-wrap] img');
    const stickyBar = document.querySelector(`#zm-sticky-${sectionId}`);
    const stickyPrice = stickyBar?.querySelector('[data-zm-sticky-price]');
    const stickyAdd = stickyBar?.querySelector('[data-zm-sticky-add]');
    const toast = document.querySelector(`#zm-toast-${sectionId}`);
    const toastMsg = toast?.querySelector('[data-zm-toast-msg]');
    const sizeGuideBtn = section.querySelector('[data-zm-size-guide]');

    const state = { qty: 1, size: '', variantId: variantInput?.value };

    let toastTimer;

    initGalleryTilt(section);
    initFaq(section);
    initScrollReveals(section.closest('.shopify-section') || section.parentElement || document);

    function getActivePill() {
      return section.querySelector('[data-zm-size-pill].is-active');
    }

    function syncSizeUI(size, variantId, priceCents, note) {
      state.size = size;
      if (variantId) {
        state.variantId = variantId;
        if (variantInput) variantInput.value = variantId;
      }

      section.querySelectorAll('[data-zm-size-pill]').forEach((p) => {
        p.classList.toggle('is-active', p.dataset.size === size);
      });
      document.querySelectorAll(`#zm-sticky-${sectionId} [data-zm-sticky-size]`).forEach((p) => {
        p.classList.toggle('is-active', p.dataset.size === size);
      });

      const resolvedNote = note || SIZE_NOTES[size] || '';
      if (sizeNote) sizeNote.textContent = resolvedNote;

      if (priceCents && btnPrice) {
        const formatted = formatMoney(Number(priceCents));
        btnPrice.textContent = formatted;
        if (priceNow) priceNow.textContent = formatted;
        if (stickyPrice) stickyPrice.textContent = `${formatted}${size ? ` · ${size}` : ''}`;
      } else if (stickyPrice && size) {
        const current = stickyPrice.textContent.split('·')[0].trim();
        stickyPrice.textContent = `${current} · ${size}`;
      }
    }

    const active = getActivePill();
    if (active) {
      syncSizeUI(
        active.dataset.size,
        active.dataset.variantId,
        active.dataset.price,
        active.dataset.note || SIZE_NOTES[active.dataset.size]
      );
    }

    function onSizeClick(btn) {
      if (btn.disabled) return;
      syncSizeUI(
        btn.dataset.size,
        btn.dataset.variantId,
        btn.dataset.price,
        btn.dataset.note || SIZE_NOTES[btn.dataset.size]
      );
    }

    section.querySelectorAll('[data-zm-size-pill]').forEach((btn) => {
      btn.addEventListener('click', () => onSizeClick(btn));
    });
    document.querySelectorAll(`#zm-sticky-${sectionId} [data-zm-sticky-size]`).forEach((btn) => {
      btn.addEventListener('click', () => onSizeClick(btn));
    });

    section.querySelector('[data-zm-qty-plus]')?.addEventListener('click', () => {
      state.qty = Math.min(state.qty + 1, 9);
      qtyVal.textContent = state.qty;
      if (qtyInput) qtyInput.value = state.qty;
    });

    section.querySelector('[data-zm-qty-minus]')?.addEventListener('click', () => {
      state.qty = Math.max(state.qty - 1, 1);
      qtyVal.textContent = state.qty;
      if (qtyInput) qtyInput.value = state.qty;
    });

    section.querySelectorAll('[data-zm-thumb]').forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        section.querySelectorAll('[data-zm-thumb]').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (mainImg && thumb.dataset.img) {
          mainImg.src = thumb.dataset.img;
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
        }
        const countEl = section.querySelector('[data-zm-gallery-count]');
        const total = section.querySelectorAll('[data-zm-thumb]').length || 1;
        if (countEl) countEl.textContent = `${index + 1} / ${total}`;
      });
    });

    function showToast(message) {
      if (!toast) return;
      if (toastMsg) toastMsg.textContent = message;
      toast.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2600);
    }

    async function addToCart(qty) {
      const variantId = state.variantId || variantInput?.value;
      if (!variantId) return;

      addBtn?.setAttribute('disabled', 'disabled');
      stickyAdd?.setAttribute('disabled', 'disabled');

      try {
        const res = await fetch(
          window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: qty })
          }
        );

        if (!res.ok) throw new Error('Add to cart failed');

        const item = await res.json();
        const sizeLabel = state.size || '';
        showToast(
          `Added ${qty} × ${item.product_title || 'Zora Slides'}${sizeLabel ? ` (${sizeLabel})` : ''} to your cart`
        );

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        const cartCount = document.querySelector('.cart-count, [data-cart-count]');
        if (cartCount) {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          cartCount.textContent = cart.item_count;
          cartCount.classList.add('is-visible');
        }
      } catch (err) {
        showToast('Could not add to cart. Please try again.');
        console.error(err);
      } finally {
        addBtn?.removeAttribute('disabled');
        stickyAdd?.removeAttribute('disabled');
      }
    }

    form?.addEventListener('submit', (e) => {
      e.preventDefault();
      addToCart(state.qty);
    });

    stickyAdd?.addEventListener('click', () => addToCart(1));

    section.querySelector('[data-zm-buy-now]')?.addEventListener('click', async () => {
      const variantId = state.variantId || variantInput?.value;
      if (!variantId) return;
      try {
        const res = await fetch(
          window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: state.qty || 1 })
          }
        );
        if (!res.ok) throw new Error('Buy now failed');
        window.location.href = window.Shopify?.routes?.root
          ? `${window.Shopify.routes.root}checkout`
          : '/checkout';
      } catch (err) {
        showToast('Could not start checkout. Please try again.');
        console.error(err);
      }
    });

    sizeGuideBtn?.addEventListener('click', () => {
      const inline = section.querySelector('[data-zm-size-inline]');
      if (inline) {
        const open = inline.hasAttribute('hidden');
        if (open) {
          inline.removeAttribute('hidden');
          sizeGuideBtn.setAttribute('aria-expanded', 'true');
          sizeGuideBtn.classList.add('is-open');
        } else {
          inline.setAttribute('hidden', '');
          sizeGuideBtn.setAttribute('aria-expanded', 'false');
          sizeGuideBtn.classList.remove('is-open');
        }
        return;
      }
      const target =
        document.getElementById('zm-size-guide') ||
        document.getElementById('size-guide') ||
        document.getElementById('zm-pdp-faq') ||
        document.getElementById('faq');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    const buyAccords = section.querySelector('[data-zm-buy-accords]');
    if (buyAccords) {
      buyAccords.querySelectorAll('details.zm-pdp-buy-accord').forEach((detail) => {
        detail.addEventListener('toggle', () => {
          if (!detail.open) return;
          buyAccords.querySelectorAll('details.zm-pdp-buy-accord').forEach((other) => {
            if (other !== detail) other.open = false;
          });
        });
      });
    }
    const heroEl = document.querySelector('.zm-hero, .zm-pdp-hero');
    const buyEl = section;
    if (stickyBar) {
      window.addEventListener(
        'scroll',
        () => {
          const sc = window.scrollY;
          const trigger = heroEl
            ? heroEl.offsetTop + Math.min(heroEl.offsetHeight * 0.45, 420)
            : buyEl.offsetTop + 240;
          stickyBar.classList.toggle('is-visible', sc > trigger);
        },
        { passive: true }
      );
    }
  });

  // Catch reveals outside buy-section root (close band etc. are inside article)
  if (!document.querySelector('[data-zm-buy-section]')) {
    initScrollReveals(document);
  }
})();
